import { Box, Text } from "@chakra-ui/react";
import React from "react";
import { currencyFormatter } from "../../../Utils/formatUtils";

export const BillingTotals = ({ total, charged, gained }) => {
  return (
    <Box
      mt="1.5rem"
      background="menu.200"
      padding="0.4rem"
      fontSize="0.9em"
      textAlign="center"
    >
      <>
        <Text as="span" fontSize="1.1em" color="text.500" px={"1rem"}>
          Cantidad de pedidos:
          {total}
        </Text>
        <Text as="span" fontSize="1.1em" color="text.500" px={"1rem"}>
          Facturado: {currencyFormatter(charged)}
        </Text>
        <Text as="span" fontSize="1.1em" color="text.500" px={"1rem"}>
          Ganancia: {currencyFormatter(gained)}
        </Text>
      </>
    </Box>
  );
};
